export var safeTrack = function safeTrack(event, data) {
  if (typeof analytics !== "undefined") {
    analytics.track(event, data);
  }
};
export var ProductImpression = function ProductImpression(data) {
  return safeTrack("Product Impression", data);
};
export var ClickThroughProduct = function ClickThroughProduct(data) {
  return safeTrack("Click-through to Product", data);
};
export var mapCollectionCarouselData = function mapCollectionCarouselData(product) {
  return {
    designerId: product.designerId,
    designerName: product.designerName,
    designerURL: product.designerURL,
    dressId: product.dressId,
    label: product.label,
    platform: product.platform,
    product: product.product,
    productContract: product.productContract,
    productEmbellishment: product.productEmbellishment,
    productFabric: product.productFabric,
    productGownLength: product.productGownLength,
    productId: product.productId,
    productLineItemId: product.productLineItemId,
    productNeckline: product.productNeckline,
    productPricePoint: product.productPricePoint,
    productSilhouette: product.productSilhouette,
    productSize: product.productSize,
    productStyle: product.productStyle,
    productTopPick: product.productTopPick,
    productTrainLength: product.productTrainLength,
    productType: product.productType,
    productVisible: product.productVisible,
    productSleeves: product.productSleeves,
    source: product.source
  };
};